export const errorMessages = {
  missingData: {
    title: 'Missing data on Header',
    description: 'Please check Header - There is missing information on the Header including any required Adjustments.',
  },
  noProductsEntered: {
    title: 'No Products Entered',
    description: 'No products have been entered, please enter at least 1 product line to continue.',
  },
  checkProducts: {
    title: 'Please check your products',
    description:
      'Sorry, something went wrong whilst checking your products, please review any cells highlighted in red.',
  },
  missingInvoiceNumbers: {
    title: 'Missing Invoice Numbers',
    description: 'Please enter all invoice references.',
  },
};

const nullToBlank = (x) => {
  if (x?.result) {
    return nullToBlank(x.result);
  }

  if (x === null || x === undefined) {
    return '';
  }
  return typeof x === 'string' ? x.trim() : x;
};

const nullToBlankUppercase = (x) => {
  const value = nullToBlank(x);
  return typeof value === 'string' ? value.toUpperCase() : value;
};

export const processDataForSpreadsheet = (
  items,
  hasMultipleInvoice,
  hasMultipleConsignors,
  vatOptions,
  preferenceOptions
) => {
  const rows = items.map((obj) => [
    ...(hasMultipleInvoice ? [{ text: nullToBlankUppercase(obj.InvoiceNumber) }] : []),
    { text: nullToBlankUppercase(obj.commodityCode) },
    { id: obj?.id, text: nullToBlankUppercase(obj.origin) },
    { text: nullToBlankUppercase(obj.description) },
    { text: nullToBlank(Math.round(obj.noOfPkgs)) },
    { text: nullToBlankUppercase(obj.typeOfPkgs) },
    { text: nullToBlank(obj.grossKG) },
    { text: nullToBlank(obj.netKG) },
    { text: nullToBlank(obj.loadValue) },
    { text: nullToBlank(obj.quantity) },
    { text: nullToBlankUppercase(obj.healthCert) },
    { text: nullToBlankUppercase(obj.catchCert) },
    { text: nullToBlankUppercase(obj.meursing) },
    { text: nullToBlankUppercase(obj.organic) },
    {
      text: nullToBlankUppercase(vatOptions.find((opt) => parseInt(opt.id) === parseInt(obj.VAT))?.data),
    },
    { text: nullToBlankUppercase(obj.RGR) },
    {
      text: nullToBlankUppercase(preferenceOptions.find((opt) => opt.id === obj.preferential)?.data),
    },
    ...(hasMultipleConsignors ? [{ text: nullToBlankUppercase(obj.Consignorid) }] : []),
    { text: nullToBlank(obj.exciseProductType) },
    { text: nullToBlankUppercase(obj.exciseTaxCode) },
  ]);
  return rows;
};

export const hasRowsWithoutInvoiceNumbers = (rows, invoiceNumberIndex) =>
  rows?.some((row) => {
    return !row[invoiceNumberIndex]?.text || row[invoiceNumberIndex].text.trim() === '';
  });

export const DRAFT_LOAD_STATUSES = ['Draft', 'CM8 Draft', 'On Hold (Potential Duty)', 'Waiting for Customer'];
